/* Movataa — Global JS */

/* ── Price formatter: show just the number (e.g. 999 instead of Rs. 999.00) ── */
(function () {
  function formatPrices() {
    document.querySelectorAll(
      '.price-item--regular, .price-item--sale, .price-item--last'
    ).forEach(function (el) {
      var raw = el.textContent.trim();
      // Extract digits only (handles "Rs. 999.00", "₹999.00", "999.00" etc.)
      var match = raw.match(/[\d,]+/);
      if (match) {
        var num = match[0].replace(/,/g, '');
        // Remove trailing .00 from decimals
        num = num.replace(/\.00$/, '');
        el.textContent = num;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatPrices);
  } else {
    formatPrices();
  }

  // Re-run after variant change (Shopify updates price dynamically)
  document.addEventListener('variant:changed', formatPrices);
  document.addEventListener('price:update', formatPrices);

  // MutationObserver — catch any dynamic price update
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          node.querySelectorAll && node.querySelectorAll(
            '.price-item--regular, .price-item--sale'
          ).forEach(function (el) {
            var raw = el.textContent.trim();
            var match = raw.match(/[\d,]+/);
            if (match) el.textContent = match[0].replace(/,/g, '').replace(/\.00$/, '');
          });
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

}());
